export enum BreakoutCreateMode {
    InitialSetup = 'InitialSetup',
    AssignAuto = 'AssignAuto',
    AssignManual = 'AssignManual',
    AllowChoice = 'AllowChoice'
}
